import { useEffect, useRef } from "react";

const useScrollEffect = (imagePos: number) => {
  const imageListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (imageListRef.current) {
      imageListRef.current.scrollTo({
        left: imagePos * 520,
        behavior: "smooth"
      });
    }
  }, [imageListRef, imagePos]);

  return { imageListRef };
};
export default useScrollEffect;
